<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Date Input
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<ng-container *ngIf="isBrowser;else noJsContent">
  <div class="content content--modifier-height">
  
    <div class="content__row">
      <div class="content__col">
        <h2>Smart Insight Date Range</h2>
        <maced-date-input dateInputId="smartInsightDateRange" useCase="smart-insight" placeholder="Choose Date"
          rangePickerDescription="Progress data reflects the dates you choose. Trend indicators show whether performance is up, down, or unchanged compared with the previous period."
          [defaultQuickRange]="defaultRange" [quickRanges]="quickRanges" [datepickerLabel]="'Date picker'" [closeAriaLabel]="'Close'"
          [(ngModel)]="smartInsightRange" [min]="newMinDate" [max]="newMaxDate" [cancelLabel]="'Cancel'" [applyLabel]="'Apply'"
          [selectDateRangeLabel]="'Selected date range'" [toLabel]="'to'" [format]="'d MMM y'" datePickerReference="datePickerReference14">
        </maced-date-input>
        <p *ngIf="smartInsightRange">Result: {{ smartInsightRange[0] | date:'d MMM yyyy' }} - {{ smartInsightRange[1] | date:'d MMM yyyy' }}</p>
      </div>
    </div>

    <div class="content__row">
      <div class="content__col">
        <h2>Date Input: ngModel</h2>
        <maced-date-input  locale = 'en-EN' dateInputId="dateInputId1" label="Date" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaDateHidden]="true"
          [placeholder]="fullDatePlaceholder" [placeholderValue]="placeholderValue" [(ngModel)]="dateNgModel" datePickerReference="datePickerReference1">
          <ng-container ngProjectAs="[message]">
            <div class="c-input-group__help-text">
              This is helper text
            </div>
          </ng-container>
        </maced-date-input>
        <p *ngIf="dateNgModel">Result: {{ dateNgModel._d }}</p>
      </div>
    </div>
  
    <div class="content__row">
      <div class="content__col">
        <h2>Date Range Input: ngModel</h2>
        <maced-date-input dateInputId="dateInputId2" locale = 'en-EN' label="Date Range" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaDateHidden]="true"
           [placeholder]="placeholderDateRange" [placeholderValue]="placeholderValue" [hasRange]="true"
          [format]="'dd MMM yyyy'" [(ngModel)]="dateRangeNgModel" datePickerReference="datePickerReference2">
          <ng-container ngProjectAs="[message]">
            <div class="c-input-group__help-text">
              This is helper text
            </div>
          </ng-container>
        </maced-date-input>
        <p *ngIf="dateRangeNgModel">
          Result: {{ dateRangeNgModel[0]._d }} - {{ dateRangeNgModel[1]._d }}
        </p>
      </div>
    </div>
  
    <div class="content__row">
      <div class="content__col">
        <h2>Date Input: Form Control</h2>
        <maced-date-input dateInputId="dateInputId3" label="Date" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaDateHidden]="true"
          [placeholder]="fullDatePlaceholder" [placeholderValue]="placeholderValue" [formControl]="dateFormControl" datePickerReference="datePickerReference3">
        </maced-date-input>
        <p *ngIf="dateFormControl.value">Result:- {{ dateFormControl.value._d }}</p>
      </div>
    </div>
  
    <div class="content__row">
      <div class="content__col">
        <h2>Date Range Input: Form Control</h2>
        <maced-date-input dateInputId="dateInputId4" label="Date Range" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaDateHidden]="true"
           [placeholder]="placeholderDateRange" [placeholderValue]="placeholderValue" [hasRange]="true"
          [format]="'dd MMM yyyy'" [formControl]="dateRangeFormControl" datePickerReference="datePickerReference4">
        </maced-date-input>
        <p *ngIf="dateRangeFormControl.value">
          Result: {{ dateRangeFormControl.value[0]._d }} - {{ dateRangeFormControl.value[1]._d }}
        </p>
      </div>
    </div>
  
    <div class="content__row">
      <div class="content__col">
        <h2>Angular Form</h2>
        <form [formGroup]="form" (ngSubmit)="submit()" id="form1">
          <maced-date-input dateInputId="dateInputId5" label="Date" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaRequired]='true' [ariaDateHidden]="true"
             [placeholder]="placeholder" [placeholderValue]="placeholderValue" formControlName="date"
            [required]="true" datePickerReference="datePickerReference5"
            [hasError]="(form.controls.date.touched || submitted) && form.controls.date.errors?.required">
            <ng-container ngProjectAs="[message]">
              <div role="alert" class="c-input-group__error"
                *ngIf="(form.controls.date.touched || submitted) && form.controls.date.errors?.required">
                This field is required
              </div>
            </ng-container>
          </maced-date-input>
  
          <maced-date-input dateInputId="dateInputId6" label="Date Range" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaRequired]='true' [ariaDateHidden]="true"
             [placeholder]="placeholderDateRange" [placeholderValue]="placeholderValue" [hasRange]="true"
            [format]="'dd MMM yyyy'" [required]="true" formControlName="dateRange"
            datePickerReference="datePickerReference6"
            [hasError]="(form.controls.dateRange.touched || submitted) && form.controls.dateRange.errors?.required">
            <ng-container ngProjectAs="[message]">
              <div role="alert" class="c-input-group__error"
                *ngIf="(form.controls.dateRange.touched || submitted) && form.controls.dateRange.errors?.required">
                This field is required
              </div>
            </ng-container>
          </maced-date-input>
        <h2>Angular form with formID</h2>
          <maced-date-input dateInputId="dateInputId11" label="Date" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaRequired]='true' [ariaDateHidden]="true"
             [placeholder]="placeholder" [placeholderValue]="placeholderValue" formControlName="dateForm"
            [required]="true" datePickerReference="datePickerReference5" formID="form1"
            [hasError]="(form.controls.dateForm.touched || submitted) && form.controls.dateForm.errors?.required">
            <ng-container ngProjectAs="[message]">
              <div role="alert" class="c-input-group__error"
                *ngIf="(form.controls.dateForm.touched || submitted) && form.controls.dateForm.errors?.required">
                This field is required
              </div>
            </ng-container>
          </maced-date-input>
          <maced-button buttonId="submit1" label="Submit" form="form1" buttonType="submit"></maced-button>
        </form>
        <br>
        <p *ngIf="form.value"> 
          Result: {{ form.value | json }}
        </p>
      </div>
    </div>
  
    <div class="content__row">
      <div class="content__col">
        <h2>Date Picker Disabled</h2>
        <maced-date-input dateInputId="dateInputId7" label="Date" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaDateHidden]="true"
          [placeholder]="fullDatePlaceholder" [placeholderValue]="placeholderValue" [(ngModel)]="dateDisabled" [disabled]="true"
          datePickerReference="datePickerReference7">
          <ng-container ngProjectAs="[message]">
            <div class="c-input-group__help-text">
              This is helper text
            </div>
          </ng-container>
        </maced-date-input>
        <maced-date-input dateInputId="dateInputId8" label="Date Range" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaDateHidden]="true"
           [placeholder]="placeholderDateRange" [placeholderValue]="placeholderValue" [hasRange]="true"
          [format]="'dd MMM yyyy'" [(ngModel)]="dateRangeDisabled" [disabled]="true"
          datePickerReference="datePickerReference8">
          <ng-container ngProjectAs="[message]">
            <div role="alert" class="c-input-group__help-text">
              This is helper text
            </div>
          </ng-container>
        </maced-date-input>
      </div>
    </div>
  
    <div class="content__row">
      <div class="content__col">
        <h2>Date Picker: Invalid filled date</h2>
        <maced-date-input dateInputId="dateInputId9" label="Date" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaDateHidden]="true"
          [placeholder]="fullDatePlaceholder" [placeholderValue]="placeholderValue" [(ngModel)]="dateInvalid" [hasError]="true"
          [ariaInvalid]="true" [ariaRequired]="true" [required]="true"
          datePickerReference="datePickerReference9">
        </maced-date-input>
      </div>
    </div>
  
    <div class="content__row">
      <div class="content__col">
        <h2>Date Picker: Min Max Range</h2>
        <h3>Date Picker:Select dates From {{ minDate }} To {{ maxDate }}:</h3>
        <maced-date-input dateInputId="dateInputId10" label="Date" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaDateHidden]="true"
          [placeholder]="placeholder" [placeholderValue]="placeholderValue" [(ngModel)]="dateMinMax" [min]="minDate" [max]="maxDate"
          datePickerReference="datePickerReference10">
        </maced-date-input>
      </div>
    </div>
  
    <div class="content__row">
      <div class="content__col">
        <h2>Date Range Input: ngModel with different formate</h2>
        <maced-date-input dateInputId="dateInputId12" label="Date Range" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaDateHidden]="true"
           [placeholder]="placeholderDateRange" [placeholderValue]="placeholderValue" [hasRange]="true"
          [format]="'dd.MM.yyyy'" [(ngModel)]="dateRangeNgModel" datePickerReference="datePickerReference12">
          <ng-container ngProjectAs="[message]">
            <div class="c-input-group__help-text">
              This is helper text
            </div>
          </ng-container>
        </maced-date-input>
        <p *ngIf="dateRangeNgModel">
          Result: {{ dateRangeNgModel[0]._d }} - {{ dateRangeNgModel[1]._d }}
        </p>
      </div>
    </div>
  
    <div class="content__row">
      <div class="content__col">
        <h2>Date Picker: With specific period</h2>
        <h3>Date Picker:Select dates From {{ newMinDate }} To {{ newMaxDate }}:</h3>
        <maced-date-input dateInputId="dateInputId13" label="Date Range" [ariaLabel]="ariaLabel" [ariaLabelMobile]="ariaLabelMobile" [ariaDateHidden]="true"
           [placeholder]="placeholderDateRange" [placeholderValue]="placeholderValue"[min]="newMinDate" [max]="newMaxDate"
          [format]="'dd-MM-yyyy'" [isSelectionRange]="true" [(ngModel)]="dateRangeValue" datePickerReference="datePickerReference13" [hasRange]="true">
          <ng-container ngProjectAs="[message]">
            <div class="c-input-group__help-text">
              This is helper text
            </div>
          </ng-container>
        </maced-date-input>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #noJsContent>
  <div class="content content--modifier-height">
      <div class="content__row">
        <form action="/date-input" method="get">
          <h2>Simple Date Picker</h2>
          <div class="c-input-group">
            <input type="date" class="c-input-group__control" id="selectedDate" name="selectedDate" placeholder="MM/DD/YYYY" [value]="selectedValue">
            <input type="submit" class="u-button u-button--default u-button--square u-button--large">
          </div>
          
          <p>Input value: {{selectedValue}}</p>
        </form>
      </div>
      <div class="content__row">
        <form action="/date-input" method="get">
          <h2>Simple Date Picker Range</h2>
          <div class='c-input-group'>
            <label for="from" class="c-input-group__label">From:</label>
            <input type="date" id="from" name="from" class="c-input-group__control" [value]="selectedFrom">
            <label for="to" class="c-input-group__label">To:</label>
            <input type="date" id="to" name="to" class="c-input-group__control" [value]="selectedTo">
            <input type="submit" class="u-button u-button--default u-button--square u-button--large">
        </div>
         <p>Input value: {{selectedFrom}} - {{selectedTo}}</p>
        </form>
      </div>
  </div>
</ng-template>
